export default __webpack_public_path__ + "static/media/patient.5e83db24.svg";